// extracted by mini-css-extract-plugin
export default {"container":"login_container__GrURe","promo":"login_promo__uabRL","logo":"login_logo__TnbLa","headline":"login_headline__tIEAn","login-form":"login_login-form__zwBOd"};